module.exports = __webpack_public_path__ + "static/img/12.a6efe75.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/eng/12.png
// module id = 0TuZ
// module chunks = 0